module.exports = __webpack_public_path__ + "static/media/FISH-MATIC.c1a8f9e3.svg";